import { initConfig } from '@cian/config/browser';
import { initGlobalEventsLogs } from '@cian/events-log';
import { init as initGlobalsBehaviors } from '@cian/global-behaviors/browser';
import { initHttpApiUnsafe, setup as setupHttpApi } from '@cian/http-api/browser';
import { initLogger } from '@cian/logger/browser';
import { initTelemetry, setup as setupTelemetry } from '@cian/telemetry/browser';
import { init as initWeb } from '@cian/web/browser';

export function setupDependencies(): void {
  setupTelemetry();
  setupHttpApi({});
}

export function initDependencies(): void {
  initConfig();
  initLogger();
  initTelemetry();
  initHttpApiUnsafe();
  initWeb();
  initGlobalsBehaviors();
  initGlobalEventsLogs();
}
